
import React, { PropTypes } from 'react';

import {
  HelpBlock,
  Button,
  FormGroup, FormControl,
  Grid, Row, Col
} from 'react-bootstrap';

import AlertForm from './AlertForm';
import FieldGroup from './FieldGroup';

const ContactForm = ({
  state, emailField, nameField, subjectField, messageBodyField,
  handleSubmit, handleChange, handleAlertDismiss
}) => {
  const { msg, visible, bsStyle, messageTitle } = state.alert;
  const emailFieldState = state[emailField.id];
  const nameFieldState = state[nameField.id];
  const subjectFieldState = state[subjectField.id];
  const messageBodyFieldState = state[messageBodyField.id];

  return (
    <div>
      <Grid>
        <Row>
          <Col md={2} xs={1} />

          <Col md={8} xs={10}>
            <AlertForm
              msg={msg}
              visible={visible}
              handleAlertDismiss={handleAlertDismiss}

              messageTitle={messageTitle}
              bsStyle={bsStyle}
            />

            <form>
              <FieldGroup
                validationState={emailFieldState.validation}

                helpVisibility={emailFieldState.helpVisibility}
                help={emailFieldState.helpMsg}

                onChange={handleChange}

                // Props passed through
                id={emailField.id}
                type={emailField.type}
                placeholder={emailField.placeholder}
                // label={emailField.label}
              />

              <FieldGroup
                validationState={nameFieldState.validation}

                // helpVisibility={nameFieldState.helpVisibility}
                // help={nameFieldState.helpMsg}

                onChange={handleChange}

                // Props passed through
                id={nameField.id}
                type={nameField.type}
                placeholder={nameField.placeholder}
              />

              <FieldGroup
                validationState={subjectFieldState.validation}

                // helpVisibility={subjectFieldState.helpVisibility}
                // help={subjectFieldState.helpMsg}

                onChange={handleChange}

                // Props passed through
                id={subjectField.id}
                type={subjectField.type}
                placeholder={subjectField.placeholder}
              />

              <FormGroup
                controlId={messageBodyField.id}
                onChange={handleChange}
                validationState={messageBodyFieldState.validation}

                id={messageBodyField.id}
              >
                <FormControl
                  componentClass={messageBodyField.type}
                  placeholder={messageBodyField.placeholder}
                />

                <HelpBlock
                  style={{ visibility: messageBodyFieldState.helpVisibility }}
                >
                  {messageBodyFieldState.helpMsg}
                </HelpBlock>

                <FormControl.Feedback />
              </FormGroup>

              <Button type="submit" bsStyle="primary" onClick={handleSubmit}>
                Submit
              </Button>
            </form>

          </Col>

          <Col md={2} xs={1} />
        </Row>
      </Grid>
    </div>
  );
};

ContactForm.propTypes = {
  state: PropTypes.shape().isRequired,
  emailField: PropTypes.shape().isRequired,
  nameField: PropTypes.shape().isRequired,
  subjectField: PropTypes.shape().isRequired,
  messageBodyField: PropTypes.shape().isRequired,

  handleSubmit: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleAlertDismiss: PropTypes.func.isRequired
};

export default ContactForm;



// WEBPACK FOOTER //
// ./src/components/contact/ContactForm.js